import { MedOrgInfoContent } from 'pages/MedOrg/MedOrgDetailsPage/ui/MedOrgInfoContent/MedOrgInfoContent.tsx';

export const MedOrgInfoTab = () => {
  return <MedOrgInfoContent />;
};
